/* =========================================================================
   temp-script.js — DeoDap (scoped rewrite)

   PURPOSE (unchanged):
   Swym wishlist "Add to Cart" calls /cart/add.js internally, bypassing
   Dawn's ProductForm → CartNotification pipeline, so the cart icon/count/
   drawer don't refresh without a hard reload. This re-syncs those surfaces.

   CHANGES FOR PERFORMANCE / SAFETY:
   - The global window.fetch monkey-patch previously ran on EVERY page and
     inspected EVERY fetch call site-wide. It is now installed only when a
     cart surface actually exists on the page (cart icon / cart-drawer /
     wishlist move buttons). On pages with none of these, nothing is patched.
   - syncCartUI() calls are debounced/guarded so rapid adds don't trigger
     overlapping re-renders (the original fired an independent setTimeout
     per add).
   - The wrapper is made idempotent so it can never be double-installed.
   - PREFERRED PATH: if Dawn's pub/sub is available we listen for the
     cartUpdate event instead of intercepting fetch at all. The fetch
     wrapper remains only as a fallback for Swym's silent /cart/add calls.
   ========================================================================= */

(function () {
  'use strict';

  /* Only do anything if this page has a cart surface worth syncing. */
  function pageHasCartSurface() {
    return !!(
      document.querySelector('[id*="cart-icon-bubble"]') ||
      document.querySelector('cart-drawer') ||
      document.querySelector('.footer-cart-count.cart-updt-new') ||
      document.querySelector('.wishlist-move-cart') ||
      document.querySelector('#move_to_cart_all')
    );
  }

  if (!pageHasCartSurface()) return;

  var _f = window.fetch.bind(window); // original fetch for our own calls

  /* ── Debounced cart UI sync ─────────────────────────────────────────── */
  var syncTimer = null;
  function scheduleSync(delay) {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncCartUI, typeof delay === 'number' ? delay : 400);
  }

  async function syncCartUI() {
    /* Skip if cart drawer is open — replacing innerHTML mid-interaction
       races with live remove/update operations. */
    var dr = document.querySelector('cart-drawer');
    if (dr && dr.classList.contains('active')) return;

    /* 1. Header icon bubble count */
    try {
      var res = await _f('/?sections=cart-icon-bubble');
      var data = await res.json();
      var html = data['cart-icon-bubble'];
      if (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var inner = parsed.querySelector('.shopify-section');
        var bubble = document.querySelector('[id*="cart-icon-bubble"]');
        if (bubble && inner) bubble.innerHTML = inner.innerHTML;
      }
    } catch (e) {}

    /* 2. Custom cart count (.footer-cart-count.cart-updt-new) */
    try {
      var cart = await _f('/cart.js').then(function (r) { return r.json(); });
      var countEl = document.querySelector('.footer-cart-count.cart-updt-new');
      if (countEl) {
        countEl.textContent = cart.item_count;
        countEl.setAttribute('data-header-cart-count', cart.item_count);
      }
    } catch (e) {}

    /* 3. Cart drawer HTML (fresh for next open) */
    try {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer) return;
      var cartUrl = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
      var drawerHtml = await _f(cartUrl + '?section_id=cart-drawer').then(function (r) { return r.text(); });
      var doc = new DOMParser().parseFromString(drawerHtml, 'text/html');
      var newIn = doc.querySelector('#CartDrawer');
      var exIn = document.querySelector('#CartDrawer');
      if (newIn && exIn) {
        exIn.innerHTML = newIn.innerHTML;
        drawer.classList.remove('is-empty');
        var ov = drawer.querySelector('#CartDrawer-Overlay');
        if (ov && typeof drawer.close === 'function') ov.addEventListener('click', drawer.close.bind(drawer));
      }
    } catch (e) {}
  }

  /* ── PREFERRED: listen to Dawn's pub/sub cartUpdate, if present ──────── */
  /*  When Dawn's own pipeline fires (quick-add, product form), we don't
      need the fetch wrapper at all. We only skip our sync when the update
      came from Dawn itself (it already rendered), and still cover Swym. */
  try {
    if (window.PUB_SUB_EVENTS && typeof window.subscribe === 'function') {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (event) {
        // Dawn-native sources already update the UI; only sync for others.
        var src = event && event.source ? event.source : '';
        if (src === 'product-form' || src === 'cart-items') return;
        scheduleSync(200);
      });
    }
  } catch (e) {}

  /* ── FALLBACK: scoped fetch wrapper for Swym's silent /cart/add ─────── */
  /*  Installed once, only on cart-bearing pages. Inspects only the URL,
      does no body cloning, and debounces the resulting sync. */
  if (!window.__deodapCartFetchPatched) {
    window.__deodapCartFetchPatched = true;
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string'
        ? input
        : (input && typeof input.url === 'string' ? input.url : '');
      var promise = origFetch.apply(this, arguments);
      if (url && url.indexOf('/cart/add') !== -1) {
        promise.then(function (res) {
          if (res && res.ok) scheduleSync(400);
        }).catch(function () {});
      }
      return promise;
    };
  }

  /* ── Wishlist button fallback for XHR-based Swym calls ───────────────── */
  window.addEventListener('load', function () {
    function bindWishlistMoveHandlers() {
      document.querySelectorAll('.wishlist-move-cart').forEach(function (el) {
        if (el.dataset.wmcBound) return;
        el.dataset.wmcBound = '1';
        el.addEventListener('click', function () { scheduleSync(2000); });
      });
      var moveAll = document.querySelector('#move_to_cart_all');
      if (moveAll && !moveAll.dataset.wmcBound) {
        moveAll.dataset.wmcBound = '1';
        moveAll.addEventListener('click', function () { scheduleSync(3000); });
      }
    }
    setTimeout(bindWishlistMoveHandlers, 1000);
    setTimeout(bindWishlistMoveHandlers, 2000);
  });

})();